module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/is-pure.js
// module id = pzR0
// module chunks = 0